// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import { MenuItem, Box, Typography } from "@mui/material";

const actividades = [
  { nombre: "Jornada de Derecho Laboral Panadero", fecha: "2025-12-22" },
  { nombre: "Taller de Prevención del Abuso Laboral", fecha: "2025-11-10" },
  { nombre: "Seminario sobre Violencia y Acoso en el Trabajo", fecha: "2025-10-05" },
  { nombre: "Consultorio Jurídico Abierto", fecha: "2025-09-18" },
  { nombre: "Capacitación en Seguridad e Higiene", fecha: "2025-08-12" },
  { nombre: "Charla Motivacional para Trabajadores", fecha: "2025-07-20" },
  { nombre: "Coaching Laboral y Desarrollo Profesional", fecha: "2025-06-15" },
  { nombre: "Encuentro de Trabajadores Panaderos", fecha: "2025-05-10" },
  { nombre: "Workshop de Producción Panadera", fecha: "2025-04-04" },
  { nombre: "Círculo de Bienestar Laboral", fecha: "2025-03-01" },
];

const hoy = new Date();

const actividadesFuturas = actividades.filter((act) => new Date(act.fecha) > hoy);

function FormularioActividades() {
  return (
    <MKBox component="section" py={{ xs: 0, lg: 6 }}>
      <Typography
        variant="h4"
        fontWeight="bold"
        mb={1}
        sx={{
          marginTop: "-10rem",
        }}
      >
        Formulario inscripcion actividades sindicales
      </Typography>
      <Box
        sx={{
          width: "100%",
          height: "3px",
          backgroundColor: "#2196f3",
          mb: 4,
          marginBottom: "5rem",
        }}
      />
      <Container>
        <Grid container item>
          <MKBox
            width="100%"
            bgColor="white"
            borderRadius="xl"
            shadow="xl"
            mb={6}
            sx={{ overflow: "hidden" }}
          >
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                lg={5}
                position="relative"
                px={0}
                sx={{
                  backgroundImage: ({
                    palette: { gradients },
                    functions: { rgba, linearGradient },
                  }) =>
                    `${linearGradient(
                      rgba(gradients.dark.main, 0.8),
                      rgba(gradients.dark.state, 0.8)
                    )}, url("https://img.freepik.com/foto-gratis/sonriendo-llevar-pila-panes-horneados-panadero_1170-2313.jpg?semt=ais_hybrid&w=740&q=80")`,
                  backgroundSize: "cover",
                }}
              >
                <MKBox
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="100%"
                  height="100%"
                >
                  <MKBox py={6} pr={6} pl={{ xs: 6, sm: 12 }} my="auto">
                    <MKTypography variant="h3" color="white" mb={1}>
                      Formulario de Inscripción
                    </MKTypography>
                    <MKTypography variant="body2" color="white" opacity={0.8} mb={3}>
                      Llena el formulario para solicitar la inscripción a las actividades vigentes.
                    </MKTypography>
                    <MKBox display="flex" p={1}>
                      <MKTypography variant="button" color="white">
                        <i className="fas fa-phone" />
                      </MKTypography>
                      <MKTypography
                        component="span"
                        variant="button"
                        color="white"
                        opacity={0.8}
                        ml={2}
                        fontWeight="regular"
                      >
                        (+54) 9 2644213665
                      </MKTypography>
                    </MKBox>
                    <MKBox display="flex" color="white" p={1}>
                      <MKTypography variant="button" color="white">
                        <i className="fas fa-envelope" />
                      </MKTypography>
                      <MKTypography
                        component="span"
                        variant="button"
                        color="white"
                        opacity={0.8}
                        ml={2}
                        fontWeight="regular"
                      >
                        sindicatopanaderos@gmail.com
                      </MKTypography>
                    </MKBox>
                    <MKBox display="flex" color="white" p={1}>
                      <MKTypography variant="button" color="white">
                        <i className="fas fa-map-marker-alt" />
                      </MKTypography>
                      <MKTypography
                        component="span"
                        variant="button"
                        color="white"
                        opacity={0.8}
                        ml={2}
                        fontWeight="regular"
                      >
                        A. Gñeco 419 Sur Capital
                      </MKTypography>
                    </MKBox>
                    <MKBox mt={3}>
                      <MKButton variant="text" color="white" size="large" iconOnly>
                        <i className="fab fa-facebook" style={{ fontSize: "1.25rem" }} />
                      </MKButton>
                      <MKButton variant="text" color="white" size="large" iconOnly>
                        <i className="fab fa-twitter" style={{ fontSize: "1.25rem" }} />
                      </MKButton>
                      <MKButton variant="text" color="white" size="large" iconOnly>
                        <i className="fab fa-dribbble" style={{ fontSize: "1.25rem" }} />
                      </MKButton>
                      <MKButton variant="text" color="white" size="large" iconOnly>
                        <i className="fab fa-instagram" style={{ fontSize: "1.25rem" }} />
                      </MKButton>
                    </MKBox>
                  </MKBox>
                </MKBox>
              </Grid>
              <Grid item xs={12} lg={7}>
                <MKBox component="form" p={2} method="post">
                  <MKBox px={3} py={{ xs: 2, sm: 6 }}>
                    <MKTypography variant="h2" mb={1}>
                      Hola compañero
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                      Llena el formulario para poder inscribirte a tu actividad preferida.
                    </MKTypography>
                  </MKBox>
                  <MKBox pt={0.5} pb={3} px={3}>
                    <Grid container>
                      {/* NOMBRE */}
                      <Grid item xs={12} md={6} pr={1} mb={6}>
                        <MKInput
                          variant="standard"
                          label="Nombre"
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                        />
                      </Grid>

                      {/* APELLIDO */}
                      <Grid item xs={12} md={6} pr={1} mb={6}>
                        <MKInput
                          variant="standard"
                          label="Apellido"
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                        />
                      </Grid>

                      {/* NUMERO DE AFILIADO */}
                      <Grid item xs={12} pr={1} mb={6}>
                        <MKInput
                          variant="standard"
                          label="Número de Afiliado"
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          type="number"
                        />
                      </Grid>

                      {/* EMPRESA */}
                      <Grid item xs={12} pr={1} mb={6}>
                        <MKInput
                          variant="standard"
                          label="Empresa"
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                        />
                      </Grid>

                      {/* SELECT DE ACTIVIDADES FUTURAS */}
                      <Grid item xs={12} pr={1} mb={6}>
                        <MKInput
                          select
                          variant="standard"
                          label="Seleccionar Actividad"
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                        >
                          {actividadesFuturas.map((actividad, index) => (
                            <MenuItem key={index} value={actividad.nombre}>
                              {actividad.nombre} — {actividad.fecha}
                            </MenuItem>
                          ))}
                        </MKInput>
                      </Grid>
                    </Grid>

                    {/* BOTÓN */}
                    <Grid
                      container
                      item
                      xs={12}
                      md={6}
                      justifyContent="flex-end"
                      textAlign="right"
                      ml="auto"
                    >
                      <MKButton variant="gradient" color="info">
                        Enviar Inscripción
                      </MKButton>
                    </Grid>
                  </MKBox>
                </MKBox>
              </Grid>
            </Grid>
          </MKBox>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default FormularioActividades;
